/** Persisted pixel widths for dashboard pinned first columns. */

export const DASHBOARD_BUYER_PINNED_COL_WIDTH_KEY =
  "dashboardBuyerPinnedColWidthPx"
export const DASHBOARD_ACCOUNT_PINNED_COL_WIDTH_KEY =
  "dashboardAccountPinnedColWidthPx"

export const PINNED_COL_WIDTH_DEFAULT = 180
export const PINNED_COL_WIDTH_MIN = 100
export const PINNED_COL_WIDTH_MAX = 420

export function pinnedColWidthKeyForTable(tableId: string): string {
  return tableId === "accountAnalyticsTable"
    ? DASHBOARD_ACCOUNT_PINNED_COL_WIDTH_KEY
    : DASHBOARD_BUYER_PINNED_COL_WIDTH_KEY
}

export function loadPinnedColumnWidth(
  key: string,
  fallback = PINNED_COL_WIDTH_DEFAULT,
  min = PINNED_COL_WIDTH_MIN,
  max = PINNED_COL_WIDTH_MAX,
): number {
  try {
    const raw = globalThis.localStorage?.getItem(key)
    if (raw) {
      const n = Number.parseInt(raw, 10)
      if (Number.isFinite(n)) return Math.min(max, Math.max(min, n))
    }
  } catch {
    /* ignore */
  }
  return fallback
}

export function savePinnedColumnWidth(key: string, width: number): void {
  try {
    globalThis.localStorage?.setItem(key, String(Math.round(width)))
  } catch {
    /* ignore */
  }
}
